import React, { useCallback, useState } from "react";
import { Button, HStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import {
  getHexacoDetailedSampleReportUrl,
  HEXACO_FREE_TEST_SAMPLE_PDF_URL,
} from "../../constants/hexaco";
import HexacoSamplePdfModal, {
  HexacoSamplePdfPreview,
} from "./HexacoSamplePdfModal";

interface HexacoSamplePdfButtonsProps {
  language?: string | null;
}

const HexacoSamplePdfButtons: React.FC<HexacoSamplePdfButtonsProps> = ({
  language,
}) => {
  const { t, i18n } = useTranslation();
  const resolvedLanguage = language || i18n.resolvedLanguage || i18n.language;
  const [preview, setPreview] = useState<HexacoSamplePdfPreview | null>(null);

  const openFreeTestSample = useCallback(() => {
    setPreview({
      title: t("hexaco.purchase.samples.freeTest"),
      url: HEXACO_FREE_TEST_SAMPLE_PDF_URL,
    });
  }, [t]);

  const openDetailedSample = useCallback(() => {
    setPreview({
      title: t("hexaco.purchase.samples.detailedReport"),
      url: getHexacoDetailedSampleReportUrl(resolvedLanguage),
    });
  }, [resolvedLanguage, t]);

  const closePreview = useCallback(() => {
    setPreview(null);
  }, []);

  return (
    <>
      <HStack spacing={3} align="stretch" w="full">
        <Button
          flex={1}
          size="sm"
          variant="outline"
          colorScheme="teal"
          borderRadius="lg"
          whiteSpace="normal"
          h="auto"
          minH="44px"
          py={3}
          onClick={openFreeTestSample}
        >
          {t("hexaco.purchase.samples.freeTest")}
        </Button>
        <Button
          flex={1}
          size="sm"
          variant="outline"
          colorScheme="teal"
          borderRadius="lg"
          whiteSpace="normal"
          h="auto"
          minH="44px"
          py={3}
          onClick={openDetailedSample}
        >
          {t("hexaco.purchase.samples.detailedReport")}
        </Button>
      </HStack>

      <HexacoSamplePdfModal preview={preview} onClose={closePreview} />
    </>
  );
};

export default HexacoSamplePdfButtons;
